import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'

const StyledNoDataText = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallheadingCSS },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    display: flex;
    align-items: center;
    text-align: center;
    color: ${textWeak};
    ${xxsmallheadingCSS};
  `}
`

const NoData: FunctionComponent = () => (
  <StyledNoDataText>{translate('sports.emptyData.title')}</StyledNoDataText>
)

export default NoData
